import { create } from "zustand";

const useOnboardingStore = create((set, get) => ({
  currentStep: 1,
  setCurrentStep: (step) => set({ currentStep: step }),
}));

export default useOnboardingStore;
